import Vue from 'vue';
import OutletFilter from './outlet-filter.vue';

/**
 * Async components are not used here since there's some slight delay when
 * loading them in other async components
 */
Vue.component('outlet-filter', OutletFilter);
